import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M9.296 15.875l-3.47-3.47c-.187-.187-.44-.293-.705-.293s-.518.105-.705.293c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58c.39-.39.39-1.02 0-1.41-.187-.187-.44-.292-.705-.292s-.518.105-.705.292l-9.88 9.87z";

export default function CheckMark(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
